import Vue from "vue";
import EntityService from "./entityService";

class DesenhoNumberService {
  
  /**
   * Gera a numeração do desenho com base nos campos selecionados
   * @param {string} desenhoId - ID do registro DesenhoNumber
   * @returns {Promise<{success: boolean, sequential: string, message: string}>}
   */
  async gerarNumeracao(desenhoId) {
    try {
      // 1. Buscar dados do desenho atual
      const desenhoService = new EntityService("DesenhoNumber");
      const desenhoResponse = await desenhoService.getById(desenhoId);
      const desenho = desenhoResponse.data.data;

      // 2. Validar campos obrigatórios
      if (!desenho.CodeEqipment || !desenho.typeEquipment || !desenho.sizeDocument || 
          !desenho.pieceEquipment || !desenho.destinyDsenho || !desenho.fomatDocument) {
        return {
          success: false,
          message: "Preencha todos os campos obrigatórios antes de gerar a numeração"
        };
      }

      // 3. Buscar códigos dos relacionamentos (childrens)
      const typeEquipmentService = new EntityService("TypeEqipment");
      const typeEquipmentData = await typeEquipmentService.getById(desenho.typeEquipment);
      const typeEquipmentCode = typeEquipmentData.data.data.code || '';

      const sizeDocumentService = new EntityService("SizeDocument");
      const sizeDocumentData = await sizeDocumentService.getById(desenho.sizeDocument);
      const sizeDocumentCode = sizeDocumentData.data.data.code || '';

      const pieceEquipmentService = new EntityService("PieceEquipment");
      const pieceEquipmentData = await pieceEquipmentService.getById(desenho.pieceEquipment);
      const pieceEquipmentCode = pieceEquipmentData.data.data.code || '';

      // 4. Extrair letras dos enums
      const destinyDsenho = desenho.destinyDsenho.slice(0, 1) || ''; // Primeira letra (C, F ou M)
      const formatDocument = desenho.fomatDocument.substring(1, 2) || ''; // Segundo caractere (0,1,2,3,4)

      // 5. Montar prefixo da sequência
      const sequentialPre = `${typeEquipmentCode}-${sizeDocumentCode}-${pieceEquipmentCode}-${destinyDsenho}`;

      // 6. Buscar último registro com esse padrão
      const searchResponse = await Vue.prototype.$http.get('/Entity/DesenhoNumber/search-fields', {
        params: {
          value: sequentialPre,
          limit: 1,
          page: 1,
          mode: 'Contains',
          searchFields: 'sequential'
        }
      });

      const existingRecords = searchResponse.data.data.data;

      // 7. Montar sequência completa com formato
      let sequentialPos = `${typeEquipmentCode}-${sizeDocumentCode}-${pieceEquipmentCode}-${destinyDsenho}-${formatDocument}`;

      // 8. Verificar se o padrão mudou (comparar com o sequential atual)
      const seqCad = desenho.sequential?.split('-').slice(0, 4).join('-') || '';

      if (seqCad !== sequentialPre) {
        // Padrão mudou, calcular novo número sequencial
        if (existingRecords.length > 0) {
          const lastSequential = existingRecords[0].sequential.split("-")[5];
          const nextNumber = Number(lastSequential) + 1;
          const seq = this.leftPad(nextNumber, 3);
          sequentialPos += `-${seq}`;
        } else {
          // Primeiro registro com esse padrão
          sequentialPos += `-001`;
        }

        // 9. Atualizar o registro com a nova numeração
        desenho.sequential = sequentialPos;
        await desenhoService.insertOrUpdate(desenho);

        return {
          success: true,
          sequential: sequentialPos,
          message: `Numeração de desenho atualizada: ${sequentialPos}`
        };
      } else {
        return {
          success: true,
          sequential: desenho.sequential,
          message: `Numeração já está atualizada: ${desenho.sequential}`
        };
      }

    } catch (error) {
      console.error("Erro ao gerar numeração:", error);
      return {
        success: false,
        message: `Erro ao gerar numeração: ${error.message}`
      };
    }
  }

  /**
   * Preenche string com zeros à esquerda
   * @param {number} value - Valor a ser preenchido
   * @param {number} totalWidth - Largura total desejada
   * @param {string} paddingChar - Caractere de preenchimento (padrão: '0')
   * @returns {string}
   */
  leftPad(value, totalWidth, paddingChar = '0') {
    const length = totalWidth - value.toString().length + 1;
    return Array(length).join(paddingChar) + value;
  }
}

export default DesenhoNumberService;
